import React from "react";

const BADGE = "/brand/mata-badge.webp";
const BADGE_SM = "/brand/mata-badge-sm.webp";
const FULL = "/brand/mata-logo.webp";
export const MATA_ALT = "Monte Argentario Trail Area – M.A.T.A.";

/* Round M.A.T.A. roundel. Visual reference only — no link, no claims. */
export function MataBadge({ size = 40, className = "", testid = "mata-badge" }) {
    return (
        <img src={size <= 80 ? BADGE_SM : BADGE} alt={MATA_ALT} title={MATA_ALT} width={size} height={size}
            data-testid={testid} loading="lazy" decoding="async" draggable={false}
            className={`select-none flex-shrink-0 ${className}`} style={{ width: size, height: size }} />
    );
}

/* Full logo (roundel + M.A.T.A. wordmark), for the territory presentation. */
export function MataLogo({ className = "", testid = "mata-logo" }) {
    return <img src={FULL} alt={MATA_ALT} title={MATA_ALT} data-testid={testid} loading="lazy" decoding="async" draggable={false} className={`select-none ${className}`} />;
}

/* Badge + two-line caption, used where a short textual reference helps. */
export function MataTag({ lang = "it", size = 44, className = "", testid = "mata-tag" }) {
    const en = lang === "en";
    return (
        <div data-testid={testid} className={`inline-flex items-center gap-3 ${className}`}>
            <MataBadge size={size} testid={`${testid}-badge`} />
            <div className="leading-tight">
                <p className="font-vt text-[10px] tracking-[0.3em] uppercase text-abnormal-paper">M.A.T.A.</p>
                <p className="label-mono text-abnormal-paperDim/80">{en ? "Monte Argentario Trail Area" : "Monte Argentario Trail Area"}</p>
            </div>
        </div>
    );
}
